// extracted by mini-css-extract-plugin
module.exports = {"flameIcon":"_6c28973","flameIconBadge":"_28e3e8a"};